<app-vvr-icon [full]="false" [dark]="false" [overlay]="false" [shadow]="false"></app-vvr-icon>
<div class="container">
    <div class="topbar">
        <div class="title">
            <h1 class="h3 condensed">Declaratie indienen</h1>
        </div>
        <div class="controls">
            <div
                class="fab small"
                id="btn-Exit"
                matTooltip="Terug naar overzicht"
                matTooltipPosition="below"
                routerLink="/{{Routenames.declarationRequest}}">
                <i class="fas fa-sign-out-alt"></i>
            </div>
        </div>
    </div>
    <div class="row">
        @if (form()) {
            <div class="col-md-9">
                <form [formGroup]="form()">
                    <div class="row">
                        <mat-form-field appearance="fill" class="col-md-6">
                            <mat-label>Status</mat-label>
                            <mat-select [formControl]="form().controls.status_id" placeholder="Status">
                                @for (status of statusList; track status) {
                                    <mat-option [value]="status.id">
                                        {{status.name}}
                                    </mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field appearance="fill" class="col-md-6">
                            <mat-label>Manager</mat-label>
                            <mat-select [formControl]="form().controls.manager_id" placeholder="Manager">
                                @for (manager of managerList; track manager) {
                                    <mat-option [value]="manager.id">
                                        {{manager.name}}
                                    </mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="row">
                        <mat-form-field (click)="picker.open()" appearance="fill" class="col-md-4">
                            <mat-label>Declaratie datum</mat-label>
                            <input
                                [formControl]="form().controls.date"
                                [matDatepicker]="picker"
                                [max]="maxDate"
                                matInput
                                placeholder="Datum">
                            <mat-datepicker-toggle [for]="picker" matSuffix></mat-datepicker-toggle>
                            <mat-datepicker #picker></mat-datepicker>
                        </mat-form-field>
                        <mat-form-field appearance="fill" class="col-md-4">
                            <mat-label>Declaratie</mat-label>
                            <mat-select [formControl]="form().controls.type_id" placeholder="PBM">
                                @for (equipment of declarationTypes; track equipment) {
                                    <mat-option [value]="equipment.id">
                                        {{equipment.name}}
                                    </mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field appearance="fill" class="col-md-4">
                            <mat-label>Bedrag</mat-label>
                            <span matPrefix>€&nbsp;</span>
                            <input
                                [decimalInput]="2"
                                [formControl]="form().controls.amount"
                                appDecimalInput
                                matInput
                                placeholder="Bedrag"
                                type="text">
                            @if (form().controls.amount.errors && form().controls.amount.errors.required) {
                                <mat-error>
                                    Dit veld is verplicht
                                </mat-error>
                            }
                            @if (form().controls.amount.errors && form().controls.amount.errors.max) {
                                <mat-error>
                                    Het maximum is € 5000,00
                                </mat-error>
                            }
                        </mat-form-field>
                    </div>
                    <div class="row">
                        <mat-form-field appearance="fill" class="col-md-12">
                            <mat-label>Opmerkingen</mat-label>
                            <textarea
                                [formControl]="form().controls.comment"
                                cdkAutosizeMinRows="4"
                                cdkTextareaAutosize
                                matInput
                                placeholder="Voeg hier eventuele notities en opmerkingen toe">
                            </textarea>
                            <mat-error>Dit veld is verplicht</mat-error>
                        </mat-form-field>
                    </div>
                    @if (form().controls.status_id.value === 3) {
                        <div class="row mb-2">
                            <mat-form-field appearance="fill" class="col-md-12">
                                <mat-label>Reden van afkeuren</mat-label>
                                <textarea
                                    [formControl]="form().controls.reason"
                                    cdkAutosizeMinRows="4"
                                    cdkTextareaAutosize
                                    matInput
                                    placeholder="Voeg hier de reden van het afkeuren toe">
                                </textarea>
                                <mat-error>Dit veld is verplicht</mat-error>
                            </mat-form-field>
                        </div>
                    }
                </form>
                @if (declarationType?.distance) {
                    <div class="distances">
                        <table class="table table-striped">
                            <thead>
                                <tr>
                                    <th>
                                        Datum
                                    </th>
                                    <th>
                                        van
                                    </th>
                                    <th>
                                        naar
                                    </th>
                                    <th>
                                        afstand
                                    </th>
                                    @if (request().status_id < 2 || AuthorisationService.hasFeature('declarationManagement')) {
                                        <th class="trash-column">
                                        </th>
                                    }
                                </tr>
                            </thead>
                            <tbody>
                                @if (!form().controls.declaration_distances.controls?.length) {
                                    <tr>
                                        <td class="text-center" colspan="5">
                                            Voeg minimaal 1 rit toe
                                        </td>
                                    </tr>
                                }
                                @for (distance of form().controls.declaration_distances.controls; track distance) {
                                    <tr [formGroup]="distance">
                                        <td>
                                            <input
                                                (click)="picker.open()"
                                                [formControl]="distance.controls.date"
                                                [matDatepicker]="picker"
                                                [max]="maxDate"
                                                matInput
                                                placeholder="Datum">
                                            <mat-datepicker #picker></mat-datepicker>
                                        </td>
                                        <td>
                                            <input [formControl]="distance.controls.from" matInput placeholder="van locatie">
                                        </td>
                                        <td>
                                            <input [formControl]="distance.controls.to" matInput placeholder="naar locatie">
                                        </td>
                                        <td>
                                            <input [decimalInput]="2" [formControl]="distance.controls.distance" appDecimalInput matInput placeholder="KM's">
                                        </td>
                                        @if (request().status_id < 2 || AuthorisationService.hasFeature('declarationManagement')) {
                                            <td>
                                                <button (click)="removeDistance(distance)" color="warn" mat-icon-button>
                                                    <mat-icon class="fas fa-trash"></mat-icon>
                                                </button>
                                            </td>
                                        }
                                    </tr>
                                }
                                <tr>
                                    <td colspan="5">
                                        <button (click)="addDistance()" class="w-100" color="primary" mat-button>
                                            Rit toevoegen
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                }
                <div class="files">
                    @for (file of request().images; track file) {
                        <div class="file">
                            <div
                                (click)="openFile(file, request().images)"
                                [class.is-img]="['jpg', 'jpeg', 'png'].indexOf(file.ext) !== -1"
                                [style.background-image]="(file.file.substr(0,4) !== 'http' ? url : '') + file.file+'?access_token='+token|safeBgUrl">
                                <div class="icon">
                                    <i class="fas fa-file fa-3x"></i>
                                </div>
                                <div class="filename">
                                    {{file.name}}
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div>
        }
        <div class="col-md-3">
            @if (request()?.status_log?.length) {
                <mat-list class="row">
                    <div class="pb-0" mat-subheader>Statuswijzigingen</div>
                    @for (log of request().status_log; track log) {
                        <mat-list-item>
                            <div mat-line>
                                {{log.status.name}}
                            </div>
                            <div mat-line>
                                {{log.created_at | date:'dd MMMM yyyy HH:mm'}}
                                <br>
                                {{log.user.name}}
                            </div>
                        </mat-list-item>
                    }
                </mat-list>
            }
        </div>
    </div>
    <div class="controls-bottom">
        @if (request()?.status_id === 1) {
            <label
                #upload
                matTooltip="Upload bestand"
                matTooltipPosition="before">
                <input (change)="uploadFile($event)" hidden multiple type="file">
                <div class="fab big">
                    @if (!uploading()) {
                        <i class="fas fa-upload"></i>
                    }
                    @if (uploading()) {
                        <i class="fas fa-circle-notch fa-spin"></i>
                    }
                </div>
            </label>
        }
        @if (isCordova && request()?.status_id === 1) {
            <div
                (click)="takePicture()"
                class="fab big"
                id="btn-AddImage"
                matTooltip="Camera"
                matTooltipPosition="before">
                <i class="fas fa-camera"></i>
            </div>
        }
        @if (request()?.status_id === 1 && request()?.id) {
            <div
                (click)="delete()"
                class="fab big"
                matTooltip="Aanvraag intrekken"
                matTooltipPosition="before">
                <i class="fas fa-trash"></i>
            </div>
        }
        <div
            (click)="save()"
            [class.disabled]="saving()"
            class="fab big primary"
            id="btn-Save"
            matTooltip="Opslaan"
            matTooltipPosition="before">
            @if (!saving()) {
                <i class="fas fa-save"></i>
            } @else {
                <i class="fas fa-circle-notch fa-spin"></i>
            }
        </div>
    </div>
</div>
